/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

import { range } from '~bookwormgb/util/range'

class ProductsCarouselPlaceholder extends Component {

	render() {
		const {
			design= 'style-v1',
			limit = 3,
			placeholder = 0,
			showImage = true,
			showProductTitle = true,
			showProductPrice = true,
			showProductFormat = true,
			showProductAuthor = true,
			smColumns = 2,
			mdColumns = 2,
			lgColumns = 2,
			xlColumns = 2,
			wdColumns = 2,
		} = this.props

		let output = ''

		switch ( design ) {
			case 'style-v1':
				output = (
					<div className={ classnames( [ `products-carousel-placeholder border row flex-nowrap overflow-hidden row-cols-sm-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns } row-cols-wd-${ wdColumns }` ] ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(								
								<div className="product product__card border-right col" key={ `product-carousel-${i}` }>
									<div className="media p-3 p-md-4d875">
										{ showImage &&
											<div className="progress bg-light" style={ { width:'120px', height: '183px' } }></div>
										}
										<div className="media-body ml-3">
											{ showProductFormat &&
												<div className="badge badge-shadow w-80 d-block">
													<div className="progress bg-light"></div>
												</div>
											}

											{ showProductTitle &&
												<div className="badge badge-shadow w-80 d-block">
													<div className="progress bg-light"></div>
												</div>
											}

											{ showProductAuthor &&
												<div className="badge badge-shadow w-80 d-block">
													<div className="progress bg-light"></div>
												</div>
											}
											{ showProductPrice &&
												<div className="badge badge-shadow w-80 d-block">
													<div className="progress bg-light"></div>
												</div>
											}
										</div>
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break

			case 'style-v2':
				output = (
					<div className={ classnames( [ `products-carousel-placeholder border row flex-nowrap overflow-hidden row-cols-sm-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns } row-cols-wd-${ wdColumns }` ] ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className="product product__card border-right col" key={ `product-carousel-${i}` }>
									<div className="media p-3 p-md-4d875 row d-flex justify-content-center">
										{ showImage &&
											<div className="progress bg-light" style={ { width:'120px', height: '183px' } }></div>
										}
										{ showProductFormat &&
											<div className="badge badge-shadow w-80 mt-5">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductTitle &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}

										{ showProductAuthor &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}

										{ showProductPrice &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break

			case 'style-v3':
				output = (
					<div className={ classnames( [ `products-carousel-placeholder border row flex-nowrap overflow-hidden row-cols-sm-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns } row-cols-wd-${ wdColumns }` ] ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className="product product__card border-right col" key={ `product-carousel-${i}` }>
									<div className="media p-3 p-md-4d875 row bg-white d-flex justify-content-center">
										{ showImage &&
											<div className="progress bg-light" style={ { width:'120px', height: '183px' } }></div>
										}
										{ showProductFormat &&
											<div className="badge badge-shadow w-80 mt-5">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductTitle &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}

										{ showProductAuthor &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}

										{ showProductPrice &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break

			case 'style-v4':
				output = (
					<div className={ classnames( [ `products-carousel-placeholder row flex-nowrap overflow-hidden row-cols-sm-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns } row-cols-wd-${ wdColumns }` ] ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className="product product__card border-right col" key={ `product-carousel-${i}` }>
									<div className="media p-3 p-md-4d875 row d-flex justify-content-center">
										{ showImage &&
											<div className="progress bg-light" style={ { width:'120px', height: '183px' } }></div>
										}
										{ showProductFormat &&
											<div className="badge badge-shadow w-80 mt-5">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductTitle &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}

										{ showProductAuthor &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}

										{ showProductPrice &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break
			case 'style-v5':
				output = (
					<div className={ classnames( [ `products-carousel-placeholder row flex-nowrap overflow-hidden row-cols-sm-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns } row-cols-wd-${ wdColumns }` ] ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className={ 'product__card product col' } key={ `product-carousel-${i}` }>
									<div className="p-3 p-md-4d875 border rounded-md">
										{ showImage &&
											<div className="progress bg-light" style={ { width:'120px', height: '183px' } }></div>
										}
										{ showProductFormat &&
											<div className="badge badge-shadow w-80 mt-5">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductTitle &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}

										{ showProductAuthor &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}

										{ showProductPrice &&
											<div className="badge badge-shadow w-80 my-1">
												<div className="progress bg-light"></div>
											</div>
										}
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break

			case 'style-v6':
				output = (
					<div className={ classnames( [ `products-carousel-placeholder row flex-nowrap overflow-hidden row-cols-sm-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns } row-cols-wd-${ wdColumns }` ] ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className={ 'product__card product col' } key={ `product-carousel-${i}` }>
									<div className="p-3 p-md-4d875 border rounded-md">
										{ showImage &&
											<div className="progress bg-light" style={ { width:'120px', height: '183px' } }></div>
										}
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break

			case 'style-v7':
				output = (
					<div className={ classnames( [ `products-carousel-placeholder row flex-nowrap overflow-hidden row-cols-sm-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns } row-cols-wd-${ wdColumns }` ] ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className={ 'product__card product col' } key={ `product-carousel-${i}` }>
									<div className="p-3 p-md-4d875 border rounded-md">
										{ showImage &&
											<div className="progress bg-light" style={ { width:'120px', height: '183px' } }></div>
										}
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break

			case 'style-v8':
				output = (
					<div className={ classnames( [ `products-carousel-placeholder row flex-nowrap overflow-hidden row-cols-sm-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns } row-cols-wd-${ wdColumns }` ] ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className={ 'product__card product col' } key={ `product-carousel-${i}` }>
									<div className="p-3 p-md-4d875 border rounded-md">
										{ showImage &&
											<div className="progress bg-light" style={ { width:'120px', height: '183px' } }></div>
										}
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break

			case 'style-v9':
				output = (
					<div className={ classnames( [ `products-carousel-placeholder row flex-nowrap overflow-hidden row-cols-sm-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns } row-cols-wd-${ wdColumns }` ] ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className={ 'product__card product col' } key={ `product-carousel-${i}` }>
									<div className="p-3 p-md-4d875 border rounded-md">
										{ showImage &&
											<div className="progress bg-light" style={ { width:'120px', height: '183px' } }></div>
										}
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break
		}

		return output
	}
}

export default ProductsCarouselPlaceholder